import Echo from "laravel-echo"
import Pusher from "pusher-js"

window.Pusher = Pusher

const token = localStorage.getItem("token")

const echo = new Echo({
  broadcaster: "pusher",
  key: "9d9acc82b98463e94c5a",
  cluster: "ap1",
  forceTLS: true,

  authEndpoint: "https://admin.daherzfamilydoctors.com/api/broadcasting/auth-manual",

  auth: {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    },
  },
})

export default echo
